import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import logo from '../assets/onnize-logo.png';
import { useLocation } from 'react-router-dom';

const QrCodeCreate = ({ size = 250 }) => {
  const qrRef = useRef();
  const location = useLocation();

  // Safely get the URL from location state
  const value = location.state.url || "https://onnize.com";

  const handleDownload = () => {
    try {
      const canvas = qrRef.current.querySelector("canvas");
      if (!canvas) return;

      const url = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = url;
      link.download = "qr_code.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  return (
    <div className="qr-container">
      <div className="qr-card" ref={qrRef}>
        <QRCodeCanvas
          value={value}
          size={size}
          includeMargin={true}
          level='H'
          imageSettings={{
            src: logo,
            height: 30,
            width: 30,
            excavate: true,
          }}
        />
      </div>

      <button className="qr-button" onClick={handleDownload}>
        Download QR Code
      </button>
    </div>
  );
};

export default QrCodeCreate;